module.exports = __webpack_public_path__ + "static/asftu-748861bd59005b6012633ceac5f4ac32.webp";